export const CategoryActionTypes = {
  LIST_CATEGORIES: "list_categories",
};
